import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmeaRegion } from '@insight/toolkit-utils';
import broadcast from '@insight/toolkit-utils/lib/events/broadcast';

const CNET_SCRIPT_SRC = `cdn.cs.1worldsync.com/jsc/h1ws.js`;

const getCnetScript = () => {
  const { protocol } = window.location;
  const cnetScript = document.createElement('script');
  cnetScript.id = 'cnet-script';
  cnetScript.type = 'text/javascript';
  cnetScript.async = true;
  cnetScript.src = `${protocol === 'https:' ? 'https://' : 'http://'}${CNET_SCRIPT_SRC}`;
  return cnetScript;
};

const OverviewCNETScript = (props) => {
  const { product, config } = props;
  const isEMEA = isEmeaRegion();

  // Check and return if cloud assets is not enabled
  if (!product?.cloudAssetsEnabled) return null;

  // Generate script tag
  const cnetScript = getCnetScript();

  const fetchCnetConfig = async () => {
    window.ccs_cc_args = window.ccs_cc_args || [];
    // Add ccs args to global window ccs args
    window.ccs_cc_args.push(['mf', product?.manufacturer?.name]);
    window.ccs_cc_args.push(['pn', product?.manufacturer?.partNumber]);
    window.ccs_cc_args.push(['lang', config?.language]);
    window.ccs_cc_args.push(['market', config?.market]);
    // Set main zone id and skey
    const o = window.ccs_cc_args;
    o.push(['_SKey', config?.sKey]);
    o.push(['_ZoneId', isEMEA ? config?.mainZoneId : config?.cesZoneId]);
    // Append script tag to dom
    document.body.appendChild(cnetScript);
  };

  const cnetCallback = () => {
    broadcast('cnet:rendered');
  };

  useLayoutEffect(() => {
    if (config) {
      fetchCnetConfig();
      window.ccs_cc_ready = cnetCallback;
      return () => document.body.removeChild(cnetScript);
    }
  }, [config]);

  return isEMEA ? (
    <>
      <div id="ccs-inline-content" />
      <div id="ccs-logos" />
    </>
  ) : (
    <>
      <div id="ccs-mkt-desc" />
      <div id="ccs-inline" />
    </>
  );
};

export default OverviewCNETScript;

OverviewCNETScript.propTypes = {
  product: PropTypes.object,
  config: PropTypes.object.isRequired,
};

OverviewCNETScript.defaultProps = {
  product: {},
};
